import React from 'react';
import { Outlet } from 'react-router-dom';

const ModelOutlet = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ModelOutlet;
